<template>
  <adminTable
    :hideSeachButton="true"
    :hideResetButton="true"
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    :tableData="tableData"
    @search="getList"
  >
    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="uid" label="用户ID" width="130" />
      <el-table-column prop="username" label="用户名" width="160" />
      <el-table-column prop="phone" label="手机号码" width="160" />
      <el-table-column prop="lv_id" label="等级ID" width="160" />
      <el-table-column prop="lv_name" label="等级名称" width="160" />
      <el-table-column label="类型" width="130">
        <template #default="scope">
          {{ getLabelByVal(scope.row.type, userLevelTypeEnums) }}
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="等级描述" width="160" />
      <el-table-column prop="admin_id" label="管理员id" width="160" />
      <el-table-column prop="admin_name" label="管理员名称" width="160" />
      <el-table-column prop="create_at" label="创建时间" width="130" />
      <el-table-column prop="update_at" label="更新时间" width="130" />
    </template>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import { userLevelTypeEnums, getLabelByVal } from "../../config/enums";

const searchForm = ref({
  ip: "",
});

onMounted(() => {
  getList();
});

const { proxy } = getCurrentInstance();

const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);
const tableData = ref([]);
const getList = async () => {
  tableLoading.value = true;
  const res = await proxy.$http({
    type: "get",
    url: "/Level/getLevelLogLists",
    params: {
      page: page.value,
      limit: limit.value,
    },
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    totalList.value = res.data.total;
  }
};
</script>

<style lang="less" scoped></style>
